const { CognitoIdentityClient } = require("@aws-sdk/client-cognito-identity");
const { fromCognitoIdentityPool } = require("@aws-sdk/credential-provider-cognito-identity");
const { S3Client, S3, CreateMultipartUploadCommand, DeleteObjectCommand, GetObjectCommand, GetObjectTaggingCommand } = require("@aws-sdk/client-s3");
const { v4: uuidv4 } = require('uuid');

import { useLogin  } from '@/js/auth.js'
import { LRUCache } from 'lru-cache'


// AWS.config.apiVersions = {
//     s3: '2006-03-01',
// };


// Todo...
// * get token from store
// https://pinia.vuejs.org/core-concepts/outside-component-usage.html#single-page-applications
// /src/router/index.js

// configure s3agg/s3client with the logn parameter:
// https://docs.amazonaws.cn/en_us/sdk-for-javascript/v3/developer-guide/loading-browser-credentials-cognito.html
// login: {[COGNITO_ID]: idToken, ...}
// COGNITO_ID=cognito-idp.REGION.amazonaws.com/COGNITO_USER_POOL_ID

// https://ldarren.medium.com/access-aws-s3-with-cognito-7c96fd1038f0


const config = {
    bucketName: process.env.VUE_APP_BUCKET_SOUNDS,
    bucketRegion: process.env.VUE_APP_BUCKET_REGION,
    cognitoRegion: process.env.VUE_APP_COGNITO_REGION,
    IdentityPoolId: process.env.VUE_APP_IDENTITY_POOL,
    UserPoolId: process.env.VUE_APP_USERPOOL_ID,
    blogBucketName: process.env.VUE_APP_BUCKET_BLOG,
    blogBucketPrefix: process.env.VUE_APP_BUCKET_BLOG_PREFIX,
}




// define a new cache with ttl of 2 min
let cache = new LRUCache({max: 100, ttl: 1000 * 60 * 2})

function getS3Agg(){
    let s3Agg = cache.get('s3Agg')

    if (s3Agg) {
        return s3Agg
    }

    console.log('getting s3Agg')

    const loginStore = useLogin()
    const cognitoId = `cognito-idp.${config.bucketRegion}.amazonaws.com/${config.UserPoolId}`
    var logins = {[cognitoId]: loginStore.tokens.id_token}
    console.log(logins)

    s3Agg = new S3({
        region: config.cognitoRegion,
        credentials: getCredentials(logins)
    })

    cache.set('s3Agg', s3Agg)

    return s3Agg
}


function getCredentials(logins) {
    
    // Check if credentials are already in the cache
    let cachedCredentials = cache.get('credentials')
    if (cachedCredentials) {
        return cachedCredentials
    }
    console.log('getting credentials')
    const credentials = fromCognitoIdentityPool({
        client: new CognitoIdentityClient({ region: config.bucketRegion }),
        identityPoolId: config.IdentityPoolId,
        logins: logins,
    })

    // Store credentials in the cache
    cache.set('credentials', credentials)

    return credentials
}


function getS3Client(){
    const s3client = new S3Client({
        region: config.bucketRegion,
        credentials: fromCognitoIdentityPool({
            client: new CognitoIdentityClient({ region: config.bucketRegion }),
            identityPoolId: config.IdentityPoolId,
        }),
    })
    return s3client
}

function text2Binary(string) {
    return string.split('').map(function (char) {
        return char.charCodeAt(0).toString(2);
    }).join(' ');
}

async function addFiles(files, tags, path, bucket, setKeyUuid, encodeTags){
    let promises = []
    for (const file of Array.from(files)){
        promises.push(addFile(file, tags, path, bucket, setKeyUuid, encodeTags))
    }
    let results = []
    for (const promise of promises){
        let resp = await promise
        results.push(resp)
    }
    return results
}


function s3encode(txt){
    let encoded = btoa(txt)
    return `b64:${encoded}`
}

function s3Decode(string) {
    let parts = string.split(':')
    if (parts[0] === 'b64') {
        try {
            return atob(parts[1])
        } 
        catch {
            console.log('failed to decode the s3 tag value')
            return string
        }
    } 
    return string
}

/**
 * 
 * @param {object} object a dictionary where all values are strings
 * @returns object with the same keys but b64 encoded values
 */
function encodeObjectValsB64(object) {
    for (let [key, val] of Object.entries(object)) {
        object[key] = s3encode(val)
    }
    return object
}


async function addFile(
        file,
        tags,
        path,
        bucket = config.bucketName, 
        setKeyUuid = true,
        encodeTags = false ){

    let key
    if (setKeyUuid) {
        key = path + uuidv4()
    }  else {
        key = path + file.name
    }
    let date = new Date().toISOString()
    const s3agg = getS3Agg()

    // encode any tags from the client code if necessary
    if (Object.keys(tags).length > 0 && encodeTags === true) {
        tags = encodeObjectValsB64(tags)
    }
    
    // add the default tags
    tags.addFileDate = date
    tags.addFileName = s3encode(file.name)
    tags.addFileType = file.type

    console.log(`adding --->  ${key}`)
    console.log("---------->", file)
    console.log("---------->", tags)
    let resp = await s3agg.putObject({
        Bucket: bucket,
        Key: key,
        Body: file,
        Tagging: new URLSearchParams(tags).toString(),
    })
    // console.log("put: ", resp)
    return resp
}

async function putTextFile(
    content,
    filename,
    type = 'text/plain',
    tags,
    path,
    bucket,
    setKeyUuid,
    encodeTags ) {

    const file = new File([content], filename, { type })

    try {
        await addFile(
            file, 
            tags, 
            path, 
            bucket,
            setKeyUuid,
            encodeTags
        )
        console.log('file uploaded')

    } catch(error) {
        console.error(`error: ${error}`)
    }
}

async function deleteFile(bucket, key) {
    const s3agg = await getS3Agg()
    const command = new DeleteObjectCommand({
        Bucket: bucket,
        Key: key
    })
    console.log('deleting file')
    try {
        const response = await s3agg.send(command)
        console.log('response ----->', response)
        console.log('file deleted')
    } catch (err) {
        console.error(err)
    }
}

async function addFileMulti(){
    let key = "my-key"
    let uploadId = await getMultipartUploadId(key)
}

async function getMultipartUploadId(key) {
    const input = {
        Bucket: config.bucketName,
        Key: key,
    };
    const s3client = getS3Client()
    const cmd = new CreateMultipartUploadCommand(input);
    const response = await s3client.send(cmd);
    return response.UploadId;
}


async function getS3Files(prefix, mimes) {
    var bucketname = config.blogBucketName;
    prefix = `${config.blogBucketPrefix}/${prefix}`;
    try {
        const s3 = getS3Agg();
        const response = await s3.listObjectsV2({
            Bucket: bucketname,
            Prefix: prefix,
        });

        var items = response.Contents
        console.log('mimes', mimes)
        items = removeDirs(items)
        if (mimes != null) {
            items = filterMimes(items, mimes)
        }
        items = constructS3Url(items, bucketname)
        return items

    } catch (e) {
        console.error('Error fetching S3 objects:', e);
        throw e;
    }
};

function removeDirs(items) {
    return items.filter((item) => item.Key.slice(-1) != '/')
}

async function getS3FileBody(Bucket, Key) {
    const s3agg = await getS3Agg()
    const command = new GetObjectCommand({ Bucket, Key })
    console.log('getting object')
    try {
        const response = await s3agg.send(command)
        console.log('response ----->', response)
        // Transform the stream to a string
        const fileContent = await response.Body.transformToString('utf-8')

        console.log('object fetched successfully')
        return fileContent

    } catch (error) {
        console.error(error)
    }
}

async function getS3FileTags(Bucket, Key) {
    const s3agg = await getS3Agg()
    const command = new GetObjectTaggingCommand({ Bucket, Key })
    console.log('getting tags')
    try {
        const response = await s3agg.send(command)
        console.log('response ----->', response)
        const tags = response.TagSet
        console.log('tags fetched successfully')
        return tags

    } catch (error) {
        console.error(error)
    }
}

function filterMimes(items, mimes) {
    // hack for now...
    const extToMimes = {
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'JPG': 'image/jpeg',
        'png': 'image/png',
        'md': 'text/markdown',
        'markdown': 'text/markdown'
    }
    const getExtension = txt => txt.slice(txt.lastIndexOf(".") + 1);
    return items.filter(item => {
        return mimes.includes(extToMimes[getExtension(item.Key)])
    })
}

function constructS3Url(objects, bucketname) {
    for (const [key, value] of Object.entries(objects)) {
        value.url = `https://${bucketname}.s3.amazonaws.com/${value.Key}`
    }
    return objects
}

export {
    addFiles,
    addFile,
    putTextFile,
    deleteFile,
    s3encode,
    s3Decode,
    encodeObjectValsB64,
    getS3Files,
    getS3FileBody,
    getS3FileTags
}

